<template>
    <div>
        <div class="ranking__transition-class" >
            <transition name="ranking" appear>
                <el-card class="refine-product__transition__card-box">
                    <div slot="header" class="clearfix">
                        <h3 v-if="rankingList.length !== 0"><span class="category">{{getSelectedStoreName}}｜{{getSelectedLine}}</span><br>ランキング</br></h3>
                        <h3 v-if="rankingList.length === 0">クラス内ランキング</h3>
                        <el-button  type="text" icon="el-icon-close" @click="returnHome()" round></el-button>
                    </div>
                    <div v-if="rankingList.length === 0" class="none">
                        <p>店舗とクラスを選択して集計してください</p>
                    </div>
                    <div v-else>
                        <ul class="refine-product__transition__card-list-ul">
                            <div  v-for="(value,index) in rankingList" :key="value.classId" class="refine-product__transition__card-list-box">
                                <li class="refine-product__transition__card-list-li ranking-list__store-name">{{value.className}}</li>
                                <li class="refine-product__transition__card-list-li ranking-list__number">{{index + 1}}</li>
                                <li class="refine-product__transition__card-list-li">{{Math.floor(value.saleProfit).toLocaleString()}} 円/ {{Math.floor(value.saleNum).toLocaleString()}} 個</li>
                            </div>
                        </ul>
                    </div>
                </el-card>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                rankingList:[]
            }
        },
        computed: {
            getRankingList() {
                return this.$store.getters.getRankingCategory;
            },
            getSelectedStoreName() {
                return this.$store.getters.getSelectedStore.storeName
            },
            getSelectedLine () {
                return this.$store.getters.getSelectedProduct.line.name;
            }
        },
        methods:{
            returnHome(){
                document.getElementById("app").classList.remove("scroll-prevent");
                this.$router.push('/');
            },
            displayRanking(index){
                return this.$store.getters.getRankingStoreInformation(index)
            }
        },
        created() {
            this.rankingList = this.getRankingList.map((value) => {
                return {
                    classId: value.class.classId,
                    className: value.class.classname,
                    saleProfit: value.sum.sale,
                    saleNum: value.sum.num
                }
            }).sort((a, b) => {
                return Number(b.saleProfit) - Number(a.saleProfit)
            })
        },
        mounted(){
            document.getElementById("app").classList.add("scroll-prevent")
        }
    }
</script>

<style lang="stylus" scoped>
    .ranking__transition-class
        .ranking-enter-active, .ranking-leave-active
            transition: opacity 1s transform 1s
        .ranking-enter
            opacity : 0
            transform: translateY(100%)
        .ranking-leave-to
            opacity : 0.5
            transform: translateY(120%)
        .storeList-leave-to
            opacity : 0.5
            transform: translateY(120%)    
        >>> .el-card__body
                padding-top: 0;
                height: 90%;
        .refine-product__transition__card-box
            right: 0
            top: 0
            width: 100%
            height: 100%
            z-index : 10
            position: fixed
            margin-bottom 50px
            padding-bottom: 50px
            -webkit-overflow-scrolling: touch;
            >>> .el-card__header
                    border-bottom: 0px solid #006C6B;
                    border-top: 7px solid #006C6B;
                    
                    z-index: 10
                    box-shadow: 0px 7px 3px -3px rgba(0,0,0,0.2);
                    height: 6rem
                .clearfix
                    display: flex
                    position relative
                    justify-content: center;
                    align-items: center;
                    h3
                        margin:0
                        padding:10px
                        color:#606266;
                        .category
                            font-size: 0.9rem
                    .el-button
                        background-color: #F2F2F2;
                        right:0;
                        position: absolute
            .none
                color:#606266;
                font-weight:bold;          
            .refine-product__transition__card-list-ul
                height: 95%
                overflow : scroll
                list-style : none
                padding-left: 0
                margin-top: 0;
                -webkit-overflow-scrolling: touch;
                color:#606266;
                font-weight:bold;
                .refine-product__transition__card-list-box
                    
                    border-bottom:1px solid #EBEEF5
                    .refine-product__transition__card-list-li
                        margin-bottom: 8px
                    .ranking-list__number
                        text-align: left
                        margin-left: 20px
                        font-weight: bold
                    .ranking-list__store-name
                        font-weight: bold
                        margin-top: 10px
                        margin-bottom : -15px
</style>
